














import {Component, Vue} from "vue-property-decorator";
import {OTHER_ROUTES} from "@/constants/routes";

@Component({
  name: "History",
  components: {
  },
})
export default class History extends Vue {
  public backToStart() {
    this.$router.push({name: OTHER_ROUTES.HOME});
  }
}

